var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Item"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56937 13.4714C7.30902 13.2111 7.30902 12.789 7.56937 12.5286L11.7433 8.35472C12.0036 8.09437 12.4257 8.09437 12.6861 8.35472C12.9464 8.61507 12.9464 9.03718 12.6861 9.29753L8.51218 13.4714C8.25183 13.7318 7.82972 13.7318 7.56937 13.4714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51218 13.4714C8.25183 13.7318 7.82972 13.7318 7.56937 13.4714L3.39546 9.29753C3.13511 9.03718 3.13511 8.61507 3.39546 8.35472C3.65581 8.09437 4.07792 8.09437 4.33827 8.35472L8.51218 12.5286C8.77253 12.789 8.77253 13.2111 8.51218 13.4714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04077 13.6667C7.67258 13.6667 7.3741 13.3682 7.3741 13L7.37411 3.00004C7.37411 2.63185 7.67258 2.33337 8.04077 2.33337C8.40896 2.33337 8.70744 2.63185 8.70744 3.00004L8.70744 13C8.70744 13.3682 8.40896 13.6667 8.04077 13.6667Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrowDown);
export default __webpack_public_path__ + "static/media/line-arrow-down.88ff8c224a310a717c806e6d1160e219.svg";
export { ForwardRef as ReactComponent };